import { HttpInterceptorFn } from '@angular/common/http';
import { LANG_STORAGE_KEY } from '@shared/services/usuario/language.service';

/**
 * Añade la cabecera `Accept-Language` con el idioma activo del usuario a cada petición,
 * para que el backend (Spring MessageSource) pueda localizar mensajes de error/respuesta.
 *
 * Lee el idioma de localStorage (fuente única que mantiene LanguageService) para no acoplar
 * el interceptor —que es una función— a la inyección del servicio. `Accept-Language` es una
 * cabecera CORS segura, así que no requiere ajustes en la config de CORS del backend.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  let lang = 'es';
  try {
    lang = localStorage.getItem(LANG_STORAGE_KEY) || 'es';
  } catch {
    /* localStorage no disponible — usar default */
  }
  return next(req.clone({ setHeaders: { 'Accept-Language': lang } }));
};
